/* 布局 */
//前台
import Layout from "@views/layout";

const graveareaburialRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
        {
        path: "graveareaburial/list",
        name: "GRAVEAREABURIAL",
        meta: {
            title: "墓穴安葬管理",
            keepAlive:true
        },
        component: () => import("@views/business/graveareaburial/index.vue"),
    },
        ],
};

export default graveareaburialRouter;
